export default __webpack_public_path__ + "static/media/category-4.1cb6c3c6.svg";